import cn from 'classnames';
import type { ITimeZone } from '@dealroadshow/uikit-date-time';
import { MONTH_DAY_YEAR_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import { formatDateOrTime } from '@/creditflowresearch/ui/components/ActiveCalendar/helpers/dates';
import { EMPTY_CELL_STATE } from '@/creditflowresearch/ui/common/constants';
import HeadlineCell from '@/creditflowresearch/ui/components/creditFlow/articles/common/HeadlineCell';
import SectorIndustryCell from '@/creditflowresearch/ui/components/creditFlow/articles/common/SectorIndustryCell/SectorIndustryCell';
import { ArticlesType } from '@/creditflowresearch/ui/components/creditFlow/articles/constants';
import { ThemeType } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/themeTypes';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';
import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import articlesStyles from '@/creditflowresearch/ui/components/creditFlow/articles/articles.module.scss';
import styles from './articlesTile.module.scss';

const getColumns = (themeType: ThemeType, timeZone: ITimeZone) => ([
  ...(themeType === ArticlesType.commentary ? [] : [{
    title: 'Sec/Ind',
    name: 'id',
    width: 64,
    maxWidth: 64,
    className: cn(alignStyles.alignCenter, spacesStyles.ptn, spacesStyles.pbn),
    cellCallback: (cellProps) => <SectorIndustryCell { ...cellProps } />,
  }]),
  {
    name: 'headline',
    title: 'Headline',
    className: cn(alignStyles.alignLeft, articlesStyles.headlineCell),
    cellCallback: (cellProps) => <HeadlineCell { ...cellProps } />,
  },
  {
    name: 'publishedAt',
    title: 'date',
    width: 113,
    className: cn(alignStyles.alignRight, styles.dateCell),
    cellCallback: ({ cellData }) => (
      cellData ? formatDateOrTime(cellData, timeZone, MONTH_DAY_YEAR_FORMAT, true) : EMPTY_CELL_STATE
    ),
  },
]);

export default getColumns;
